var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a, _b, _c, _d;
import { decorator } from '../utils/instance';
export var CONTENT_TOO_LONG = 1;
export var NOTHING_TO_SEND = 2;
export var NOT_FIND_IM_NODE = 3;
export var NOT_FIND_SESSION = 4;
export var NO_CONVERSATION_SESSION = 5;
export var NO_SUPPORT_MESSAGE_TYPE = 6;
export var IM_PUSHTEXT_IMAGE = 7;
export var IM_PUSHTEXT_ORDERCARD = 8;
export var IM_PUSHTEXT_PRODUCTCARD = 9;
export var ACCS_CLOSED = 10;
export var IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD = 11;
export var IM_PUSHTEXT_FOLLOWCARD = 12;
var LANG_TXT_MAP = {
    th: (_a = {},
        _a[CONTENT_TOO_LONG] = 'ความยาวข้อความถึงขีดจำกัดสูงสุด กรุณาส่งข้อความแบบแยก',
        _a[NOTHING_TO_SEND] = 'ไม่สามารถส่งข้อความที่ว่างเปล่าได้',
        _a[NOT_FIND_IM_NODE] = 'ขออภัย มีข้อผิดพลาดบางประการเกิดขึ้นในโหนดข้อความ',
        _a[NOT_FIND_SESSION] = 'ขออภัย มีข้อผิดพลาดบางประการเกิดขึ้นในการค้นหาเซสชัน',
        _a[NO_CONVERSATION_SESSION] = 'ไม่มีการทำงานของเซสชันที่เลือก',
        _a[NO_SUPPORT_MESSAGE_TYPE] = 'ไม่รองรับประเภทข้อความ',
        _a[IM_PUSHTEXT_IMAGE] = '[รูปภาพ]',
        _a[IM_PUSHTEXT_ORDERCARD] = '[บัตรแสดงคำสั่งซื้อ]',
        _a[IM_PUSHTEXT_PRODUCTCARD] = '[บัตรแสดงสินค้า]',
        _a[IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD] = '[Voucher card]',
        _a[IM_PUSHTEXT_FOLLOWCARD] = '[Follow card]',
        _a),
    id: (_b = {},
        _b[CONTENT_TOO_LONG] = 'Panjang teks mencapai batas maksimum, silakan kirim dalam pesan terpisah.',
        _b[NOTHING_TO_SEND] = 'Pesan kosong tidak dapat dikirim.',
        _b[NOT_FIND_IM_NODE] = 'Maaf, ada kesalahan pada simpul pesan.',
        _b[NOT_FIND_SESSION] = 'Maaf, ada kesalahan pada sesi penemuan.',
        _b[NO_CONVERSATION_SESSION] = 'Tidak ada sesi aktif yang dipilih.',
        _b[NO_SUPPORT_MESSAGE_TYPE] = 'Tipe pesan tidak didukung.',
        _b[IM_PUSHTEXT_IMAGE] = '[Gambar]',
        _b[IM_PUSHTEXT_ORDERCARD] = '[Kartu pesanan]',
        _b[IM_PUSHTEXT_PRODUCTCARD] = '[Kartu produk]',
        _b[IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD] = '[Voucher card]',
        _b[IM_PUSHTEXT_FOLLOWCARD] = '[Follow card]',
        _b),
    vn: (_c = {},
        _c[CONTENT_TOO_LONG] = 'Tin nhắn dài quá giới hạn tối đa, vui lòng gửi thành các tin nhắn riêng lẻ.',
        _c[NOTHING_TO_SEND] = 'Không thể gửi tin nhắn trống.',
        _c[NOT_FIND_IM_NODE] = 'Rất tiếc, có lỗi xảy ra trong mục tin nhắn.',
        _c[NOT_FIND_SESSION] = 'Rất tiếc, có lỗi xảy ra trong phiên tìm kiếm.',
        _c[NO_CONVERSATION_SESSION] = 'Không có phiên đang hoạt động nào được chọn.',
        _c[NO_SUPPORT_MESSAGE_TYPE] = 'Không hỗ trợ loại tin nhắn này.',
        _c[IM_PUSHTEXT_IMAGE] = '[Ảnh]',
        _c[IM_PUSHTEXT_ORDERCARD] = '[Thẻ đơn hàng]',
        _c[IM_PUSHTEXT_PRODUCTCARD] = '[Thẻ sản phẩm]',
        _c[IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD] = '[Voucher card]',
        _c[IM_PUSHTEXT_FOLLOWCARD] = '[Follow card]',
        _c),
    en: (_d = {},
        _d[CONTENT_TOO_LONG] = 'Text length reaches maximum limitation, please send in separate messages.',
        _d[NOTHING_TO_SEND] = 'Empty message can not be sent.',
        _d[NOT_FIND_IM_NODE] = 'Sorry, there\'s some error happened in message node.',
        _d[NOT_FIND_SESSION] = 'Sorry, there\'s some error happened in finding sessions.',
        _d[NO_CONVERSATION_SESSION] = 'There\'s no active session selected.',
        _d[NO_SUPPORT_MESSAGE_TYPE] = 'Message type does not support.',
        _d[IM_PUSHTEXT_IMAGE] = '[Image]',
        _d[IM_PUSHTEXT_ORDERCARD] = '[Order card]',
        _d[IM_PUSHTEXT_PRODUCTCARD] = '[Product card]',
        _d[IM_PUSHTEXT_COLLECTIVE_VOUCHER_CARD] = '[Voucher card]',
        _d[IM_PUSHTEXT_FOLLOWCARD] = '[Follow card]',
        _d[ACCS_CLOSED] = 'The server is disconnected.',
        _d),
};
var I18N = (function () {
    function I18N(config) {
        this.config = config;
    }
    I18N.prototype.getTxt = function (key) {
        var lang = this.config.lang;
        var langTxtObj = LANG_TXT_MAP[lang] || {};
        return langTxtObj[key] || LANG_TXT_MAP.en[key] || '';
    };
    I18N = __decorate([
        decorator
    ], I18N);
    return I18N;
}());
export default I18N;
